import { jsx } from "react/jsx-runtime";
import { useEntity, useMutationState, EntityAccessor } from "@contember/binding";
import { useColorScheme } from "@contember/react-utils";
import { Button } from "@contember/ui";
import { listClassName, controlsThemeClassName, colorSchemeClassName } from "@contember/utilities";
import { Trash2Icon } from "lucide-react";
import { memo, useCallback } from "react";
import { usePersistWithFeedback } from "../../../ui/usePersistWithFeedback.js";
const DeleteEntityButton = memo((props) => {
  const { children, immediatePersist, className, ...rest } = props;
  const parentEntity = useEntity();
  const triggerPersist = usePersistWithFeedback();
  const isMutating = useMutationState();
  const onClick = useCallback(() => {
    if (props.immediatePersist && !confirm("Really?")) {
      return;
    }
    parentEntity.deleteEntity();
    if (props.immediatePersist && triggerPersist) {
      triggerPersist().catch(() => {
      });
    }
  }, [triggerPersist, props.immediatePersist, parentEntity]);
  const colorScheme = useColorScheme();
  if (!(parentEntity instanceof EntityAccessor)) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Button,
    {
      square: true,
      borderRadius: "full",
      distinction: "seamless",
      size: "small",
      ...rest,
      className: listClassName([
        controlsThemeClassName("danger", ":hover"),
        colorSchemeClassName(colorScheme),
        className
      ]),
      disabled: isMutating || rest.disabled,
      onClick,
      children: children || /* @__PURE__ */ jsx(Trash2Icon, {})
    }
  );
});
DeleteEntityButton.displayName = "DeleteEntityButton";
export {
  DeleteEntityButton
};
//# sourceMappingURL=DeleteEntityButton.js.map
